import axios from "axios";
import { fetchPackageReducer, paymentInitiatedReducer, purchaseHistoryReducer, premiumSubReducer, subscriptionModalReducer } from "./slice/subscriptionSlice";
import { store } from "../redux/store";
import { ERROR_MESSAGES, TOAST } from '../../utils/constants'
import { checkActiveSubscription } from "../../utils/activeSubs";
export const purchasePackage = async (product_id, subscriber_uid, email) => {
    // console.log(`subscription_uid: ${subscriber_uid}`)
    // console.log(`product_uid: ${product_id}`)
    try {
        store.dispatch(fetchPackageReducer(true))
        const selectedOperator = JSON.parse(window.localStorage.getItem('afri_selected_operator'))
        const operator_uid = selectedOperator.operator_uid
        // API URL
        const url = `https://tvanywhereonline.com/cm/api/purchase/?operator_uid=${operator_uid}`;

        // Request headers
        const headers = {
            'Password': process.env.REACT_APP_API_PASSWORD,
            'Content-Type': 'application/json'
        };

        // Request body
        const body = {
            subscriber_uid: subscriber_uid,
            subscription_type: 'one-off',
            email: email,
            bill: true,
            product_id: product_id,
            medium: 'web'
        };

        // Making POST request using Axios with async/await
        const response = await axios.post(url, body, { headers });
        if (response.data.status === "ok") {
            store.dispatch(paymentInitiatedReducer(response.data.payment_status));
            store.dispatch(fetchPackageReducer(true))
            window.location.href = response.data.redirect_url || '/home';   
        }
       

    } catch (error) {
        store.dispatch(fetchPackageReducer(false))
        TOAST.error(ERROR_MESSAGES.SUBSCRIPTION.subscriptionFailed)
        // console.error('An error occurred:', error.message);
    }
}

export const fetchPurchaseHistory = async (dispatch, active) => {
    try {
        // API URL
        const selectedOperator = JSON.parse(window.localStorage.getItem('afri_selected_operator'))
        const subscriber_uid = window.localStorage.getItem('afri_username')
        const operator_uid = selectedOperator.operator_uid
        const url = `https://tvanywhereonline.com/cm/api/orders/?operator_uid=${operator_uid}&subscriber_uid=${subscriber_uid}&limit=30&status=${active}`;

        // Request headers
        const headers = {
            'Password': process.env.REACT_APP_API_PASSWORD,
            'Content-Type': 'application/json'
        };

        
        // Making POST request using Axios with async/await
        const response = await axios.get(url, { headers });

        if (response.data.status === "ok") {
            dispatch(purchaseHistoryReducer(response.data.data))
            const premiumSub = checkActiveSubscription(response.data.data)

            dispatch(premiumSubReducer(premiumSub))
        }   


    } catch (error) {
        // console.error('An error occurred:', error.message);
    }
}

export const cancelSubscription = async (product_id) => {
    store.dispatch(fetchPackageReducer(true))
    try {
        // API URL
        const selectedOperator = JSON.parse(window.localStorage.getItem('afri_selected_operator'))
        const subscriber_uid = window.localStorage.getItem('afri_username')
        const operator_uid = selectedOperator.operator_uid
        const deleteUrl = `https://tvanywhereonline.com/cm/api/purchase/?operator_uid=${operator_uid}&method=delete`

        // Request headers
        const headers = {
            'Password': process.env.REACT_APP_API_PASSWORD,
            'Content-Type': 'application/json'
        };
        
        // Request body
        const body = {
            "subscriber_uid": subscriber_uid,
            "product_id": product_id,
            "medium": "web"
        }
        
        // First API call - delete
        const deleteResponse = await axios.post(deleteUrl, body, { headers });
        
        if (deleteResponse.data.status === "ok") {
            // Second API call - update
            const updateUrl = `https://tvanywhereonline.com/cm/api/purchase/?operator_uid=${operator_uid}&method=update`
            const updateResponse = await axios.post(updateUrl, body, { headers });
            
                        if (updateResponse.data.status === "ok") {
                                // Clear loading state and close modal first so UI can update
                                store.dispatch(fetchPackageReducer(false))
                                store.dispatch(subscriptionModalReducer({ isOpen: false }))

                                // Delay the redirect slightly to allow React to re-render and remove loaders
                                setTimeout(() => {
                                    try {
                                        window.location.href = '/home'
                                    } catch (e) {
                                        // fallback: reload
                                        window.location.reload()
                                    }
                                }, 200)

                                return;
                        } else {
                                // Update failed
                                store.dispatch(fetchPackageReducer(false))
                                TOAST.error(ERROR_MESSAGES.SUBSCRIPTION.subscriptionFailed)
                        }
        } else {
            // Delete failed
            store.dispatch(fetchPackageReducer(false))
            TOAST.error(ERROR_MESSAGES.SUBSCRIPTION.subscriptionFailed)
        }

    } catch (error) {
        store.dispatch(fetchPackageReducer(false))
        TOAST.error(ERROR_MESSAGES.SUBSCRIPTION.subscriptionFailed)
        // console.error('Cancellation error:', error.message);
    }
}